export default {
    totalEmployee: 'Total Employee',
    checkInOnTime: 'Check-In Ontime',
    late: 'Late',
    absent: 'Absent',
    onstie: 'Onsite',
    leave: 'Leave'
}
